<template>
  <div v-if="has_fantasy_tips_store">
    <info-feed v-if="hasMatchInfoData" :parentRoute="parentRoute" />
    <div class="fg-preloader-wrap" v-if="is_loading">
      <div class="fg-preloader"></div>
    </div>
    <no-data-box v-else-if="!hasMatchInfoData" />
  </div>
</template>
<script>
import { cssImport } from '../../../assets/js/common';
import fantasyTipsStore from "../../../store/modules/matchDetails/fantasyTipsStore";
import InfoFeed from "./InfoFeed";
import NoDataBox from "./NoDataBox";

export default {
  props: ["parentRoute"],
  data() {
    return {
      componentPromises: null,
    };
  },
  components: {
    InfoFeed,
    NoDataBox,
  },
  computed: {
    has_fantasy_tips_store() {
      return !!(this.$store.state && this.$store.state.fantasy_tips_store && this.$store.state.fantasy_tips_store.fantasy_tips_store_filled);
    },
    /**shared state end */
    is_loading: {
      get() {
        return this.$store.state.fantasy_tips_store.is_loading;
      },
      set(val) {
        return (this.$store.state.fantasy_tips_store.is_loading = val);
      },
    },
    hasMatchInfoData() {
      return this.$store.state.fantasy_tips_store.hasMatchInfoData;
    },
  },
  async serverPrefetch() {
    // serverPrefetch runs only on serverside
    this.$store.registerModule("fantasy_tips_store", fantasyTipsStore);
    return await this.$store.dispatch("fantasy_tips_store/fetchFeed");
  },
  beforeMount() {
    this.registerModule();
  },
  mounted() {
    let hasStore = this.has_fantasy_tips_store;
    if(!hasStore){
      cssImport(["/static-assets/css/match-info.css"]);
      this.callApis();
    }
  },
  methods: {
    registerModule() {
      let hasComponentModule = this.$store.hasModule("fantasy_tips_store");
      if (!hasComponentModule) {
        this.$store.registerModule("fantasy_tips_store", fantasyTipsStore, {
          preserveState: this.has_fantasy_tips_store,
        });
      }
    },
    callApis() {
      this.componentPromises = this.initApis();
      this.componentPromises.then(() => {
        this.is_matches_loaded = true;
      });
    },
    async initApis() {
      return await this.$store.dispatch("fantasy_tips_store/fetchFeed");
    },
  },
  beforeDestroy() {
    // reset tips data
  },
  unmounted() {
    if (this.componentPromises) {
      this.componentPromises.then(() => {
        this.$store.unregisterModule("fantasy_tips_store");
      });
    } else {
      this.$store.unregisterModule("fantasy_tips_store");
    }
  },
};
</script>
